@if (!!challenge) {
  <div class="content" *leaModal="modalParams">
    <div class="modal-body">
      <div class="row row-center">
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
          <div class="row row-center">
            <div class="col-xl-2 col-lg-2 col-md-2 col-12 col-xs-12">
              <div ngbDropdown class="d-inline-block">
                <button class="btn btn-secondary btn-image" id="dropdownBasic1" ngbDropdownToggle
                  [disabled]="!isEditable">
                  <img src="{{image.url}}" />
                </button>
                <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownBasic1">
                  <div class="icons-selector"><!--
                    -->@for (challengeImage of images; track challengeImage) {
                    <div>
                      <div>
                        <img (click)="loadImage(challengeImage); checkForm();" src="{{challengeImage.url}}" />
                      </div>
                    </div>
                    }<!--
                  --></div>
                </div>
              </div>
            </div>
            <div class="col-xl-10 col-lg-10 col-md-10 col-12 col-xs-12">
              <div class="form-group">
                <label>{{'challenge_manage_label_name' | translate}}</label>
                <input [ngClass]="{ 'has-danger': shouldDisplayError(challenge.title) }" [appAutofocus]="isEditable" type="text" [(ngModel)]="challenge.title"
                  (ngModelChange)="checkForm();" name="name" class="form-control flat" [disabled]="!isEditable">
                @if (shouldDisplayError(challenge.title)) {
                  <span class="error-message">{{ 'challenge_manage_error_title_empty' | translate }}</span>
                }
              </div>
            </div>
          </div>
          @if (!!challenge.status) {
            <div class="row row-center">
              <div class="col-12">
                <div class="form-group">
                  <label>{{'app_status' | translate}}</label>
                  <input type="text" [ngModel]="'challenge_' +  challenge.status | translate"
                    [placeholder]="'challenge_manage_status_placeholder' | translate" name="status"
                    class="form-control flat" [disabled]="true">
                  @if (challenge.status == 'DRAFT') {
                    <div class="comment"><span>{{ 'challenge_manage_publication_comment' | translate }}</span></div>
                  }
                </div>
              </div>
            </div>
          }
          @if (!!challenge.challengeId) {
            <div class="row row-center">
              <div class="col-12">
                <div class="form-group">
                  <label>{{'challenge_identifier' | translate}}</label>
                  <input type="text" [ngModel]="challenge.challengeId"
                    name="challengeId"
                    class="form-control flat" [disabled]="true">
                </div>
              </div>
            </div>
          }
          <div class="row row-center">
            <div class="col-6 col-lg-4">
              <div class="form-group">
                <label>{{'challenges_add_label_start_date' | translate}}</label>
                <input type="date" placeholder="yyyy-mm-dd" [ngModel]="challenge.startDate | date:'yyyy-MM-dd'"
                  name="startDate" class="form-control flat"
                  (ngModelChange)="challenge.startDate = readDate($event); checkForm();" [attr.expired]="isExpired()"
                  [disabled]="!isEditable">
              </div>
            </div>
            <div class="col-6 col-lg-4">
              <div class="form-group">
                <label>{{'challenges_add_label_end_date' | translate}}</label>
                <input type="date" placeholder="yyyy-mm-dd" [ngModel]="challenge.endDate  | date:'yyyy-MM-dd'"
                  name="endDate" class="form-control flat"
                  (ngModelChange)="challenge.endDate = readDate($event); checkForm();" [disabled]="!isEditable">
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <label>{{'challenges_add_label_theme' | translate}}</label>
              <div ngbDropdown class="d-block w-100">
                <button class="btn btn-standard" id="dropdownBasic2" ngbDropdownToggle [disabled]="!isEditable">
                  {{label}}
                  <i class="fa fa-angle-down" aria-hidden="true"></i>
                </button>
                <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownBasic2">
                  @for (t of availableThemes; track t) {
                    <button class="dropdown-item"
                    (click)="challenge.themeCode = t.code; label = t.label; checkForm();">{{t.label}}</button>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="row row-center">
            <div class="col-12">
              <div class="form-group">
                <label>{{'app_description' | translate}}</label>
                <textarea [ngClass]="{ 'has-danger': shouldDisplayError(challenge.description) }"  [(ngModel)]="challenge.description" (ngModelChange)="checkForm()" name="description"
                class="form-control description flat"  required [disabled]="!isEditable"></textarea>
                @if (shouldDisplayError(challenge.description)) {
                  <span class="error-message">{{ 'challenge_manage_error_description_empty' | translate }}</span>
                }
              </div>
            </div>
          </div>
          @if (true || !!challenge.creationDate || !!challenge.author) {
            <div class="row row-center">
              @if (!!challenge.author) {
                <div class="col-6">
                  <div class="form-group">
                    <label>{{'challenge_manage_creator' | translate}}</label>
                    <input type="text" [ngModel]="challenge.author.firstname + ' ' + challenge.author.lastname"
                      name="creator" class="form-control flat" [disabled]="true">
                  </div>
                </div>
              }
              @if (!!challenge.creationDate) {
                <div class="col-6">
                  <div class="form-group">
                    <label>{{'group_manage_creation_date' | translate}}</label>
                    <input type="date" placeholder="yyyy-MM-dd" [ngModel]="challenge.creationDate | date:'yyyy-MM-dd'"
                      name="creationDate" class="form-control flat" [disabled]="true">
                  </div>
                </div>
              }
            </div>
          }
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
          <div class="row row-center">
            <div class="col-12">
              @if (challenge.conditions.nbTrip) {
                <div class="form-group">
                  <label>{{'challenges_add_label_conditions' | translate}}
                    <i class="icons8-info-2 info-icon" ngbTooltip="{{'challenges_add_info_conditions' | translate}}"></i>
                  </label>
                  <div class="row row-center">
                    <div class="col-xl-3 col-lg-3 col-md-3 col-4" style="margin-top: 8px">
                      <span class="condition-label">{{'challenges_add_trip_number' | translate}}</span>
                    </div>
                    <div class="col-xl-9 col-md-9 col-lg-9 col-8" style="margin-top: 8px">
                      <div class="row row-center">
                        <div class="col-2 text-right">
                          <span class="option-slide">{{travelMin}}</span>
                        </div>
                        <div class="col-8">
                          <app-slider [min]="travelMin" [max]="travelMax" [value]="challenge.conditions.nbTrip"
                          (valueChanged)="challenge.conditions.nbTrip=$event; checkForm();" [disabled]="!isEditable"></app-slider>
                        </div>
                        <div class="col-2 text-left">
                          <span class="option-slide">{{travelMax}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row row-center">
                    <div class="col-xl-3 col-lg-3 col-md-3 col-4" style="margin-top: 8px">
                      <span class="condition-label">{{'challenges_add_label_distance' | translate}}</span>
                    </div>
                    <div class="col-xl-9 col-md-9 col-lg-9 col-8" style="margin-top: 8px">
                      <div class="row row-center">
                        <div class="col-2 text-right">
                          <span class="option-slide">{{distanceMin}} {{metricStringService.unitSystem.distanceUnit}}</span>
                        </div>
                        <div class="col-8">
                          <app-slider [min]="distanceMin" [max]="distanceMax" [value]="distance" [step]="5" (valueChanged)="distance=$event; checkForm();"
                          [disabled]="!isEditable"></app-slider>
                        </div>
                        <div class="col-2 text-left">
                          <span class="option-slide">{{distanceMax}} {{metricStringService.unitSystem.distanceUnit}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="row row-center">
            <div class="col-12">
              @if (isEditable) {
                <div class="form-group">
                  <label>{{'challenges_add_label_type'| translate}} </label>
                  <!-- The multi-group options allow you to individually or team-class the drivers of the selected groups.-->
                  <div class="row row-center">
                    <div class="col-12">
                      <input type="radio" value="0" name="visibility" [(ngModel)]="challenge.type" [value]="0"
                        (change)="onchallengeTypeChange()"> {{'challenges_add_type_all'| translate}} &nbsp;
                        <i class="icons8-info-2 info-icon" data-html="true"
                        ngbTooltip="{{'challenges_add_info_type_all' | translate}}"></i>
                      </div>
                      <div class="col-12">
                        <input type="radio" value="1" name="visibility" [(ngModel)]="challenge.type"
                          (ngModelChange)="checkForm()" [value]="1" (change)="onchallengeTypeChange()">
                        {{'challenges_add_type_single_group' | translate}}&nbsp;
                        <i class="icons8-info-2 info-icon" data-html="true"
                        ngbTooltip="{{'challenges_add_info_type_single_group' | translate }}"></i>
                      </div>
                      <div class="col-12">
                        <input type="radio" value="2" name="visibility" [(ngModel)]="challenge.type" [value]="3"
                          (change)="onchallengeTypeChange()"> {{'challenges_add_type_inter_group' | translate}}&nbsp;
                          <i class="icons8-info-2 info-icon" data-html="true"
                          ngbTooltip="{{'challenges_add_info_type_inter_group' | translate }}"></i>
                        </div>
                        <!--<div class="col-6"><input type="radio" value="3" name="visibility" [(ngModel)]="challenge.type" [value]="3"> Multi groupes, par équipes</div>-->
                      </div>
                    </div>
                  }
                  @if (!isEditable) {
                    <div class="form-group">
                      <label>{{'challenges_add_label_type'| translate}}</label> :
                      <span>{{typeDescriptions[challenge.type]}}</span>
                    </div>
                  }
                </div>
              </div>
              @if (isEditable && challenge.type > 0) {
                <div class="row row-center">
                  <div class="form-group operators">
                    @if (challenge.type == 1) {
                      <label>{{'challenges_add_label_group_sing' | translate}}&nbsp;<i
                        class="icons8-info-2 info-icon" data-html="true"
                      ngbTooltip="{{'challenges_add_group_info' | translate}}"></i></label>
                    }
                    @if (challenge.type == 3) {
                      <label>{{'challenges_add_label_group_plur' | translate}}&nbsp;<i
                        class="icons8-info-2 info-icon" data-html="true"
                      ngbTooltip="{{'challenges_add_group_info' | translate}}"></i></label>
                    }
                    <div placement="left" ngbDropdown class="d-inline-block">
                      <i class="fa fa-1x fa-plus-circle green" id="dropdownBasic1" ngbDropdownToggle></i>
                      <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-scroll">
                        <table class="table table-light">
                          @for (group of getGroups(); track group) {
                            <tr>
                              <td (click)="addToGroup(group)">{{group.label}}</td>
                            </tr>
                          }
                        </table>
                      </div>
                    </div>
                    @for (groupChallenge of groupsChallenge; track groupChallenge) {
                      <div class="operator">
                        <div class="row row-center">
                          <div class="col-11">
                            <span>{{groupChallenge.label}}</span>
                          </div>
                          <div class="col-1 trash text-center">
                            <i class="icons8-trash" (click)="removeChallenge(groupChallenge)"></i>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
              @if (!isEditable && ((challenge.type > 0) && (challenge.groups !== undefined))) {
                <div class="row row-center">
                  <div class="form-group operators">
                    @if (challenge.type == 1) {
                      <label>{{'challenges_add_readonly_group_sing' | translate}}</label>
                    }
                    @if (challenge.type == 3) {
                      <label>{{'challenges_add_readonly_group_plur' | translate}}</label>
                    }
                    @for (groupChallenge of challenge.groups; track groupChallenge) {
                      <div class="operator">
                        <div class="row row-center">
                          <div class="col-12">
                            <span>{{groupChallenge.label}}</span>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
              @if (challenge.rules && isHyperAdmin()) {
                <div class="row row-center">
                  <div class="col-12">
                    <div class="form-group">
                      <label>{{'challenges_add_label_rules'| translate}}</label>
                      <a target="_blank" [routerLink]="['challenge-rules']" [queryParams]="{challengeId: challengeId}">
                        <i class="rules-link-icon"></i>
                      </a>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
